import { render, staticRenderFns } from "./pointsExchange.vue?vue&type=template&id=495bdddb&scoped=true"
import script from "./pointsExchange.vue?vue&type=script&lang=js"
export * from "./pointsExchange.vue?vue&type=script&lang=js"
import style0 from "./pointsExchange.vue?vue&type=style&index=0&id=495bdddb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495bdddb",
  null
  
)

export default component.exports